import React from "react";
import SwitchMaestro from "./SwitchMaestro";
import {
  Card,
  Box,
  Typography,
  Alert,
  AlertTitle,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export function SwitchMaestroRender({ refState, id, qsBody, setqsBody, opciones_de_pantalla }) {
  const condicion_validacion = refState.configuraciones.filter(
    (c) => c.opciones.tipo.id === 13 && c.opciones.condicion === "n"
  );

  if (condicion_validacion.length > 0) {
    return <PageCondicionNoCumplida conf={condicion_validacion[0]} />;
  }
  return (
    <Card style={{ paddingRight: "5px", flex: 1 }} data-component='SwitchMaestroRender'>
      {refState.configuraciones
        .sort((a, b) => a.opciones.orden - b.opciones.orden)
        .map((item, indiceConf) => {
          return (
            <SwitchMaestro
              key={item.opciones.id_a}
              _key={item.id_a}
              configuracion={item}
              id={id}
              indiceConf={[indiceConf]}
              qsBody={qsBody}
              setqsBody={setqsBody}
              opciones_de_pantalla={opciones_de_pantalla}
            />
          );
        })}
    </Card>
  );
}

export const PageCondicionNoCumplida = ({ conf }) => {
  const mensaje = conf.opciones.validacion_mensaje_error;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "200px",
        padding: 2,
      }}
    >
      <Alert
        icon={<InfoOutlinedIcon fontSize="large" />}
        severity="info"
        sx={{
          width: "100%",
          maxWidth: 480,
          textAlign: "center",
          boxShadow: 2,
          borderRadius: 3,
          //bgcolor: "#ffffff", // blanco limpio sobre fondo gris
          border: "1px solid #cce4ff", // borde azul suave
          //color: "#007bff", // texto azul llamativo
          '& .MuiAlert-icon': {
            color: '#ffffff',
            margin: 'auto',
          },
        }}
        className="PageCondicionNoCumplida bg-primary"
      >
        <AlertTitle
          sx={{ textAlign: "center", fontWeight: "bold", fontSize: "1.2rem" }}
        >
          Información
        </AlertTitle>
        <Typography sx={{ textAlign: "center", mt: 1, fontSize: "1rem" }}>
          {mensaje || "No tiene permisos para ver esta página"}
        </Typography>
      </Alert>
    </Box>
  );
};
